import React from 'react';
import '../../../../css/CustomComponents/CustomSelect.css';
import ArrowUp from '../../../../assets/icons/ArrowUp.svg';
import ArrowDown from '../../../../assets/icons/ArrowDown.svg';
import Pulse from '../../../Loader/Pulse';

class CustomSelect extends React.PureComponent {


    constructor(props) {
        super(props);
        this.state = {
            heading: this.props.heading || '',
            isListOpen: false,
            title: this.props.options[this.props.defaultIndex] || this.props.title,
            selectedIndex: this.props.defaultIndex,
            loading: false // NEW
        }
        this.toggleSelect = this.toggleSelect.bind(this);
        this.closeSelect = this.closeSelect.bind(this);
        this.selectOption = this.selectOption.bind(this);
    }

    componentDidUpdate(prevProps) {
        const { defaultIndex, options, value } = this.props;

        if (this.props.defaultIndex !== prevProps.defaultIndex) {
            this.setState({
                title: this.props.options[this.props.defaultIndex] || this.props.title
            });
        }

        if (this.props.options !== prevProps.options) {
            this.setState({
                title: this.props.options[this.props.defaultIndex] || this.props.title
            });
        }

        if (value !== prevProps.value && value !== this.state.title) {
            const foundIndex = options.indexOf(value);
            this.setState({
                title: value,
                selectedIndex: foundIndex > -1 ? foundIndex : null
            });
        }

        const { isListOpen } = this.state;

        setTimeout(() => {
            if (isListOpen) {
                window.addEventListener('click', this.closeSelect)
            }
            else {
                window.removeEventListener('click', this.closeSelect)
            }
        }, 0)
    }

    toggleSelect() {
        this.setState((prevState) => ({
            isListOpen: !prevState.isListOpen
        }))
    }

    selectOption(indx, option) {
        this.setState({ isListOpen: false });

        const value = option.value || option.label || option;

        const loaderTimer = setTimeout(() => {
            this.setState({ loading: true });
        }, 10000);

        Promise.resolve(this.props.onTypeChange(value))
            .then(() => {
                clearTimeout(loaderTimer);
                if (this.state.loading) {
                    setTimeout(() => {
                        this.setState({
                            title: option.label || option,
                            selectedIndex: indx,
                            loading: false
                        });
                    }, 500);
                } else {
                    this.setState({
                        title: option.label || option,
                        selectedIndex: indx,
                        loading: false
                    });
                }
            });
    }


    closeSelect() {
        this.setState({
            isListOpen: false
        })
    }

    render() {
        const { width, height, options, disabled,icon } = this.props;
        const { title, heading, isListOpen, selectedIndex } = this.state;

        return (
            <div
                className={`custom-select ${disabled ? "custom-select-disabled" : ""}`}
            >
                <p className='select-title'>{heading}</p>
                <div
                    className="custom-select-header"
                    onClick={() => { if (!disabled) this.toggleSelect(); }}
                    style={{ cursor: disabled ? 'not-allowed' : 'pointer', opacity: disabled ? 0.6 : 1 }}
                >
                    {icon && (
                        <span className='custom_select_icon' >
                        <img src={icon} alt='' width={25} />
                        </span>
                    )}
                    <span className="custom-select-title">
                        {this.state.loading ? <Pulse /> : (title || this.props.placeholder)}
                    </span>
                    <span className='custom_select_icon'>
                        {isListOpen ? (
                            <img width={20} src={ArrowUp} alt="" />
                        ) : (
                            <img width={20} src={ArrowDown} alt="" />
                        )}
                    </span>
                    {isListOpen && !disabled && (
                        <div className="custom-select-container">
                            {options.map((option, indx) => (
                                <div className='custom-select-icon-container'  onClick={() => {
                                        if (!option.disabled) {
                                            this.selectOption(indx, option);
                                        }
                                    }}>
                                    {option.icon && (<span>
                                        <img src={option.icon} alt='' width={"20px"} style={{margin:"5px"}}/>
                                    </span>)}
                                    <span
                                    key={indx}
                                    className={
                                        option.disabled
                                            ? "custom-select-option disabled"
                                            : selectedIndex === indx
                                                ? "custom-select-option option-selected"
                                                : "custom-select-option"
                                    }
                                   
                                >
                                    {option.label || option}
                                </span>
                                </div>
                            ))}

                        </div>
                    )}
                </div>
            </div>
        )
    }
}

export default CustomSelect;
